<template>
<vx-card class="donut-chart-card" style="overflow-x: auto; max-width: 100%;">
  <vs-row>
    <vs-col style="position: relative">
      <div class="w-full flex mt-6" style="justify-content: center; position: relative">
        <apexchart type="bar" height="200" width="100%" :options="cardOption.chartOptions" :series="cardOption.series" style="width: 100%;" ></apexchart>
      </div>
      <ul>
        <li v-if="!!labels" v-for="(data, index) in labels" :key="`donut_${index}`" @click="onClickItem(data)">
          <donut-chart-label :label="labels[index]" :unit="unit" :value="initTotal[index] | comma" :color="dataGroup.colors[index]" />
        </li>
        <li v-else v-for="(data, index) in realValue" :key="`donut_${index}`" @click="onClickItem(data)">
          <donut-chart-label :label="dataGroup.labels[index]" :unit="unit" :value="dataGroup.values[index] | comma" :color="dataGroup.colors[index]" />
        </li>
      </ul>
      <!-- header tools -->
      <div class="donut-chart-card-header">
        <span class="font-bold" style="font-size: 1em;"><i class="dot"></i>{{ title }}</span>
        <div style="justify-content: end">
          <!--  TODO: 임시로 숨겨둠 -->
          <a href="javascript:;" v-if="isMoveDetail && projectId" style="font-size:0.85em; display:flex; align-items: center; justify-content: flex-end;" @click="onClickDetail">자세히 보기<feather-icon icon="ChevronRightIcon" style="width:1.42em;"/></a>
<!--          <a v-if="isMoveWrite" href="javascript:;" style="font-size:0.85em; display:flex; align-items: center; justify-content: flex-end;" @click="onClickWrite">작성페이지 이동<feather-icon icon="ChevronRightIcon" style="width:1.42em;"/></a>-->
        </div>
      </div>
    </vs-col>
  </vs-row>

</vx-card>
</template>

<script>
import DonutChartLabel from '@/popup/DonutChartLabel'
export default {
  name: 'StackedBarChartCard',
  components: {DonutChartLabel},
  props: {
    title: String,
    unit: String,
    value: Array,
    initTotal: Array,
    xAxis: Array,
    labels: Array,
    isMoveDetail: {
      type:Boolean,
      default: true
    },
    isMoveWrite: Boolean
  },
  data () {
    return {
    }
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    myLv () {
      return this.$store.state.auth.userInfo.position
    },

    realValue () {
      const maxLength = 5

      if (this.value.length) {
        const value = JSON.parse(JSON.stringify(this.value))
        if (value.length > maxLength) {
          return value.slice(0, maxLength)
        }
        return value
      } else {
        return [{label: '데이터 없음', value: 0}]
      }
    },

    xMax() {
      const sumColumn = [];
      let max = 0;

      // data의 각 index 별 합을 구한다
      for (const item of this.realValue) {
        const data = item.data;
        if (!data) continue;

        for (const [index, value] of data.entries()) {
          if (!sumColumn[index]) sumColumn[index] = 0;
          sumColumn[index] += value;
        }
      }

      // sumColumn 중 가장 큰 값을 구한다
      for (const value of sumColumn) {
        if (value > max) max = value;
      }

      return max;
    },

    dataGroup () {
      const labels = []
      const colors = ['#0058FF', '#21D59B', '#FFC700', '#F99600', '#EA5455']
      const values = []

      this.realValue.map(value => {
        if (value.label) labels.push(value.label)
        if (value.value || value.value === 0) {
          values.push(value.value)
        }
      })

      return { labels, colors, values }
    },

    cardOption () {
      return {
        series: this.realValue,
        chartOptions: {
          plotOptions: {
            bar:{
              horizontal: true,
              dataLabels: {
                total: {
                  enabled: false,
                },
              }
            }
          },
          chart: {
            redrawOnParentResize: false,
            redrawOnWindowResize: false,

            toolbar: {
              show: false
            },
            type: 'bar',
            stacked: true,
          },
          dataLabels: {
            enabled: true,
            style: {
              fontSize: '11px',
              fontWeight: 300,
            },
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  show: false
                }
              }
            }
          ],
          xaxis: {
            categories: this.xAxis,
            labels: {
              show: false
            },
            max: this.xMax,
          },
          yaxis: {
            title: {
              text: undefined,
            },
            labels: {
              show: true,
              style: {
                fontSize: '14px',
                fontWeight: 400,
                fontFamily: 'Noto Sans KR,Montserrat, sans-serif',
                colors: '#3c3c3c'
              }
            },
          },
          grid: {
            show: false,
          },
          colors: this.dataGroup.colors,
          labels: this.dataGroup.labels,
          legend: { show: false }
        }
      }
    }

  },

  methods: {
    onClickDetail () {
      this.$emit('detail')
    },
    onClickWrite () {
      this.$emit('write')
    },
    onClickItem (data) {
      this.$emit('item', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.donut-chart-card {
  position: relative;

  .total {
    display: grid;
    justify-content: center;
    align-items: center;
    text-align: center;

    .total-value {
      font-size: 1.71em;
      font-weight: bold;
      color:#000
    }

    .total-unit {
      font-size: 1em;
      font-weight: bold;
      color:#757575
    }
  }
}
.donut-chart-card-header {
  display: flex;
  justify-content: space-between;
  align-items: start;

  position: absolute;
  top:0;
  left:0;
  right:0;

}
</style>
